import Classes from './Header.module.scss';
import NavBar from '../navbar/NavBar';
import ModalView from '../../components/modal-view/ModalView';
import {useModal} from '../../context/ModalContext';
import JoinForm from '../../components/join-form/JoinForm';

const Header = () => {
    const {showJoinForm, handleJoinFormClose} = useModal();
    return (
        <div className={`${Classes.headerWrap}`}>
            <NavBar/>
            {showJoinForm && (
                <ModalView
                    show={showJoinForm}
                    handleClose={handleJoinFormClose}
                    additionalClassName={`${Classes.joinModalWrap} position-relative`}
                    size={'md'}
                    closeBtnClass={Classes.closeBtn}
                >
                    <JoinForm/>
                </ModalView>
            )}
        </div>
    );
};

export default Header;